import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/ktx/basic-registration-data/clinical-data/anthropometrics";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	anthropometrics: {
		id: "ktx.form.anthropometrics",
		defaultMessage: "Antropometria"
	},
	weight: {
		id: "ktx.form.anthropometrics.weight",
		defaultMessage: "Testsúly"
	},
	height: {
		id: "ktx.form.anthropometrics.height",
		defaultMessage: "Magasság"
	},
	bmi: {
		id: "ktx.form.anthropometrics.bmi",
		defaultMessage: "BMI"
	},
	bsa: {
		id: "ktx.form.anthropometrics.bsa",
		defaultMessage: "BSA"
	}
});

const fields: { [key: string]: FieldData } = {
	weight: {
		type: "field",
		path: ["weight"],
		label: messages.weight,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	height: {
		type: "field",
		path: ["height"],
		label: messages.height,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	bmi: {
		type: "field",
		path: ["bmi"],
		label: messages.bmi,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number", disabled: true } }
	},
	bsa: {
		type: "field",
		path: ["bsa", "dubois"],
		label: messages.bsa,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number", disabled: true } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{ width: 6, field: fields.weight },
				{ width: 6, field: fields.height }
			]
		},
		{
			columns: [
				{ width: 6, field: fields.bmi },
				{ width: 6, field: fields.bsa }
			]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_anthropometrics",
	value: {
		schemaId: "anthropometrics",
		title: messages.anthropometrics,
		validator,
		fieldset,
		applyCurrentDate: true,
		defaults: [
			{
				path: ["height"],
				query: { interpretation: { vocab: "ktx", code: "height" } }
			}
		]
	}
};
